/**
 * Esfuerzo de una tarea como tres botones con nombre y frase corta (Rápida / Media / Grande), más un «?»
 * con la explicación. Sirve en la ficha (un clic guarda) y en el formulario de creación (un clic elige).
 *
 * Son botones con `aria-pressed` (se leen como «pulsado» con lector de pantalla). La web solo los
 * deshabilita: el permiso real lo decide la API.
 */
import { useId } from 'react';
import {
  DESCRIPCION_ESFUERZO,
  ESFUERZOS,
  ETIQUETA_ESFUERZO,
  type Esfuerzo,
} from '@cdtec-backlog/contrato';
import './SelectorEsfuerzo.css';

export const AYUDA_ESFUERZO =
  'Cuánto trabajo se calcula que implica. Sirve para repartir la carga y planificar.';

interface Props {
  valor: Esfuerzo;
  onElegir: (esfuerzo: Esfuerzo) => void;
  deshabilitado?: boolean;
  /** Id de un texto que explica por qué está deshabilitado (p. ej. «solo quien la creó…»). */
  descritoPor?: string;
}

/** Título «Esfuerzo» con su ayuda accesible: el texto está siempre en el DOM y se muestra con hover o foco. */
export function EtiquetaEsfuerzo() {
  const idAyuda = useId();
  return (
    <span className="esfuerzo__titulo">
      Esfuerzo
      <span className="esfuerzo__ayuda">
        <button
          type="button"
          className="esfuerzo__signo"
          aria-label="¿Qué es el esfuerzo?"
          aria-describedby={idAyuda}
        >
          ?
        </button>
        <span id={idAyuda} role="tooltip" className="esfuerzo__tip">
          {AYUDA_ESFUERZO}
        </span>
      </span>
    </span>
  );
}

export function SelectorEsfuerzo({ valor, onElegir, deshabilitado = false, descritoPor }: Props) {
  return (
    <div className="esfuerzo" role="group" aria-label="Esfuerzo" aria-describedby={descritoPor}>
      {/* El contenedor mide su ancho (container query): angosto, las opciones van una por fila. */}
      <div className="esfuerzo__opciones">
        {ESFUERZOS.map((esfuerzo) => (
          <button
            key={esfuerzo}
            type="button"
            className="esfuerzo__opcion"
            aria-pressed={valor === esfuerzo}
            disabled={deshabilitado}
            onClick={() => {
              if (valor !== esfuerzo) onElegir(esfuerzo);
            }}
          >
            <b>{ETIQUETA_ESFUERZO[esfuerzo]}</b>
            <small>{DESCRIPCION_ESFUERZO[esfuerzo]}</small>
          </button>
        ))}
      </div>
    </div>
  );
}
